import React, { useState } from "react";
import { MediaObject } from "../../types/MediaObject";
import { Stack } from "@mui/material";
import DisplayMediaObject from "../MediaObjectSection/DisplayMediaObject";
import { AttachFile, Email, FaxOutlined, ScannerOutlined, SendOutlined } from "@mui/icons-material";

type DisplayableMediaObjectProps = {
  mediaObject: MediaObject;
  label?: string;
};
export default function DisplayableMediaObject({ mediaObject }: DisplayableMediaObjectProps) {
  const [displayMediaObjectOpen, setDisplayMediaObjectOpen] = useState<boolean>(false);
  return (
    <>
      <Stack
        direction="row"
        spacing={1}
        onClick={() => setDisplayMediaObjectOpen(true)}
        sx={{
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        {mediaObject.fieldname === "fax" && <FaxOutlined />}
        {["bea", "beaAttachmentMerge"].includes(mediaObject.fieldname || "") && <SendOutlined />}
        {mediaObject.fieldname === "scan" && <ScannerOutlined />}
        {mediaObject.fieldname === "emailAttachmentMerge" && <Email />}
        <AttachFile />
      </Stack>
      <DisplayMediaObject
        mediaObject={displayMediaObjectOpen ? mediaObject : null}
        closeDialog={() => setDisplayMediaObjectOpen(false)}
      />
    </>
  );
}
